import React from 'react';
import subDays from '@teetsh/app/src/utils/time/subDays';
import { ArrowUturnLeftIcon as Reply } from '@heroicons/react/20/solid';
import BrandedSelect from '@teetsh/app/src/components/Form/Select2/Branded';
import { useAtom } from 'jotai';
import { CopyMethod } from './copyMethod';
import { preferedCopyMethodAtom } from './preferedCopyMethodAtom';
import { CalendarIcon as Calendar } from '@heroicons/react/24/outline';
import { Classroom } from '@teetsh/app/src/types/classroom';
import { format } from '@teetsh/app/src/utils/time/format';
import { trackEvent } from '@teetsh/app/src/queries/user/track';
import { isoDatePattern } from 'utils/time/datePatterns';
import { useOpenCopyEventsToAnotherDayModal } from 'containers/CahierJournal/CopyEventsToAnotherDayModal/atom';
import { useCopyCJSeances } from 'containers/CahierJournal/queries/useCopyCJSeances';
import { useSchoolSchoolyear } from 'containers/App/context/SchoolyearSchoolProvider';
import { ArrowDownOnSquareStackIcon } from '@heroicons/react/24/outline';
import { useOpenCopyEventsFromEDTModal } from 'containers/CahierJournal/CopyEventsFromEDTModal/useOpenCopyEventsFromEDTModal';
import { useTranslation } from 'react-i18next';
import { useUser } from '@teetsh/app/src/containers/App/context/useUser';

interface Props {
  date: Date;
  classrooms: Classroom[];
}

export function GetEventsButton(props: Props) {
  const [copyEvents, isCopyingSeances] = useCopyCJSeances();
  const { schoolyear, school } = useSchoolSchoolyear();
  const { guestMode } = useUser();
  const openCopyEventsModal = useOpenCopyEventsFromEDTModal();
  const openCopyEventsToAnotherDayModal = useOpenCopyEventsToAnotherDayModal();
  const { date } = props;
  const [preferedCopyMethod, setPreferedCopyMethod] = useAtom(
    preferedCopyMethodAtom,
  );
  const { t } = useTranslation(['common', 'cahierJournal']);
  if (guestMode?.permission === 'read') {
    return null;
  }

  return (
    <div className="fetch-seance-elsewhere">
      <BrandedSelect<CopyMethod>
        fill
        intent="primary"
        portal
        value={preferedCopyMethod}
        withoutIcon
        withoutCheck
        noDisplayCurrent
        loading={isCopyingSeances}
        options={[
          {
            label: t('cahierJournal:actions.getSeancesFromPreviousWeek'),
            value: 'previousWeek',
            icon: Reply,
            onClick: () =>
              copyEvents({
                from: subDays(date, 7),
                to: date,
                destSchoolId: school.id,
                destSchoolyearId: schoolyear.id,
                srcSchoolId: school.id,
                srcSchoolyearId: schoolyear.id,
              }).then(() => {
                trackEvent('Get CJ seances from last week', {
                  date: format(date, 'fr-FR', isoDatePattern),
                });
              }),
          },
          {
            label: t('cahierJournal:actions.getSeancesFromAnotherDay'),
            value: 'copyAnotherDay',
            icon: ArrowDownOnSquareStackIcon,
            onClick: () => {
              openCopyEventsToAnotherDayModal({
                to: date,
                classrooms: props.classrooms,
              });
              trackEvent('Get CJ seances from another day', {
                date: format(date, 'fr-FR', isoDatePattern),
              });
            },
          },
          {
            label: t('cahierJournal:actions.getSeancesFromEDT'),
            value: 'copyEdt',
            icon: Calendar,
            disabled: guestMode?.enabled,
            onClick: () => {
              openCopyEventsModal({
                date,
              });
              trackEvent('Get CJ seances from EDT', {
                date: format(date, 'fr-FR', isoDatePattern),
              });
            },
          },
        ]}
        onChange={v => setPreferedCopyMethod(v)}
      />
    </div>
  );
}
